import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getInitials, avatarColor } from "./utils";

const AssociateCard = ({ request }) => {
  const theme = useTheme();
  const t     = theme.custom;
  const color = avatarColor(request.associateName);

  return (
    <Box sx={{
      background: t.surface2, border: `1px solid ${t.border2}`,
      borderRadius: "3px", padding: "12px 14px", mb: "4px",
      display: "flex", alignItems: "center", gap: "10px",
    }}>
      {/* Avatar */}
      <Box sx={{
        width: "34px", height: "34px", borderRadius: "50%", flexShrink: 0,
        background: `${color}22`, border: `1px solid ${color}55`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'DM Mono', monospace", fontSize: "10px", fontWeight: 700, color,
      }}>
        {getInitials(request.associateName)}
      </Box>

      {/* Name + level */}
      <Box sx={{ flex: 1 }}>
        <Typography sx={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "13px", fontWeight: 600, color: t.text,
        }}>
          {request.associateName}
        </Typography>
        <Typography sx={{ fontSize: "11px", color: t.text3 }}>
  Level {request.associateLevelCode}
  {(request.currentMacName || request.macName)
    ? ` · Currently in: ${request.currentMacName || request.macName}`
    : ""}
</Typography>
      </Box>

      {/* FTE */}
      <Box sx={{ textAlign: "right", flexShrink: 0 }}>
        <Typography sx={{
          fontFamily: "'DM Mono', monospace",
          fontSize: "18px", fontWeight: 700,
          color: t.accent, lineHeight: 1,
        }}>
          {request.fte} FTE
        </Typography>
        <Typography sx={{
          fontFamily: "'DM Mono', monospace",
          fontSize: "8px", color: t.text3, mt: "2px",
        }}>
          Requested alloc.
        </Typography>
      </Box>
    </Box>
  );
};

export default AssociateCard;